import { message } from 'antd';
import {
  getSchoolTree,
  getDeptRoleList,
  addRoleUser,
  removeUserFromRole,
  orgSyncType
} from '../../services/role/role';

const everNodeChain = {};
function fucTreeRecursion(data, parentArr) {
  const currentData = data;
  const currentParentArr = parentArr;
  const transfromId = `__${currentData.deptId}`;
  let currentArr = [];
  currentArr[0] = `${currentData.deptName}${transfromId}`;
  // eslint-disable-next-line no-unused-expressions
  currentParentArr
    ? (currentArr = currentArr.concat(currentParentArr))
    : (currentArr = currentArr.concat());
  currentData.chain = [].concat(currentArr);
  currentData.chain.reverse();
  everNodeChain[transfromId] = currentData;
  (currentData.subDepts || []).forEach(item => {
    fucTreeRecursion(item, currentArr);
  });
  return everNodeChain;
}

const initState = () => {
  return {
    spinProps: {
      spinning: true,
    },
    currentselectTreeNode: {},
    selectTreeNodeKey: [],
    expandedTreeNodeKeys: [],
    schoolTreeList: [],
    deptRoleList: [],
    currentRoleList: {},
    showSelectUserModal: false,
    checkedNodes: [],
    nodeChainData: {},
  };
};

export default {
  namespace: 'countyRoleManagement',
  state: initState(),
  effects: {
    *fetchSchoolTreeList(_, { call, put }) {
      try {
        const data = yield call(getSchoolTree);

        const nodeChain = fucTreeRecursion(data);
        yield put({
          type: 'save',
          payload: {
            nodeChainData: nodeChain,
            schoolTreeList: data,
            currentselectTreeNode: data,
            selectTreeNodeKey: [data.deptId],
            expandedTreeNodeKeys: [data.deptId],
            spinProps: {
              spinning: false,
            },
          },
        });
        yield put({
          type: 'fetchDeptRoleList',
          params: { deptId: data.deptId, deptType: data.deptType },
        });
      } catch (error) {
        console.log(error);
      }
    },
    *fetchDeptRoleList({ params }, { call, put }) {
      try {
        const data = yield call(getDeptRoleList, params);
        yield put({
          type: 'save',
          payload: {
            deptRoleList: data.deptRoleList,
          },
        });
      } catch (error) {
        console.log(error);
      }
    },
    *addRoleUser({ params, currentselectTreeNode }, { call, put }) {
      try {
        yield call(addRoleUser, params);
        yield put({
          type: 'fetchDeptRoleList',
          params: {
            deptId: currentselectTreeNode.deptId,
            deptType: currentselectTreeNode.deptType,
          },
        });
        yield put({
          type: 'save',
          payload: {
            checkedNodes: [],
            showSelectUserModal: false,
          },
        });
        message.success('添加成功！');
      } catch (error) {
        console.log(error);
      }
    },
    *removeUser({ params, currentselectTreeNode }, { call, put }) {
      try {
        yield call(removeUserFromRole, params);
        yield put({
          type: 'fetchDeptRoleList',
          params: {
            deptId: currentselectTreeNode.deptId,
            deptType: currentselectTreeNode.deptType,
          },
        });
        message.success('删除岗位设置成功!');
      } catch (error) {
        console.log(error);
      }
    },
    *fetchOrgSyncType({ payload, callback }, { call }) {
      try {
        const response = yield call(orgSyncType, payload);
        if (callback) {
          callback(response)
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return { ...initState() };
    },
  },
};
